import { Config } from '@sitebase/tracking-kit';
import portsApi from '../framework/ports/portsApi';

const trackingInfo = {
  install: (options: Config): void => {
    portsApi.invoke('Tracking.install', [options]);
  },
  track: (data: object): void => {
    portsApi.invoke('Tracking.track', [data]);
  },
  updateStore: (data: object): void => {
    portsApi.invoke('Tracking.updateStore', [data]);
  },
};

export default trackingInfo;
